import Vue from 'vue';
import VueI18n from 'vue-i18n';
import areIntlLocalesSupported from 'intl-locales-supported';

Vue.use(VueI18n);

const supportedLocales = [ 'de', 'it', 'hu', 'cs', 'sr', 'sk', 'hr', 'sl', 'pl', 'ro' ];

if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!areIntlLocalesSupported(supportedLocales)) {
        // `Intl` exists, but it doesn't have the data we need, so load the
        // polyfill and patch the constructors we need with the polyfill's.
        const IntlPolyfill  = require('intl');
        Intl.NumberFormat   = IntlPolyfill.NumberFormat;
        Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
} else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = require('intl');
}

const browserLanguage = navigator.language ? navigator.language.split('-')[0] : undefined;
const FALLBACK_LOCALE = supportedLocales.indexOf(browserLanguage) >= 0 ? browserLanguage : 'de';

const numberFormats = {
    de: {
        currency: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
        amount: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};

export const i18nOptions = {
    locale: FALLBACK_LOCALE,
    fallbackLocale: FALLBACK_LOCALE,
    numberFormats,
    messages: {},
};
